import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { Goals } from '../models/goals';
import { HttpClient } from '@angular/common/http';
import { User } from '../models/user';
import { AuthService } from '../services/authService';
import { MealViewModel } from '../models/mealResponseModel';

@Component({
    selector: 'app-home-authenticated',
    templateUrl: './home-authenticated.component.html',
    styleUrl: './home-authenticated.component.scss',
    standalone: false
})
export class HomeAuthenticatedComponent implements OnInit {
  @Input() user = new User('', false);
  @Input() mealViewModels: MealViewModel[] = [];
  @Input() parentComponentGoals: Goals;

  constructor(private http: HttpClient, private authService: AuthService, private cdr: ChangeDetectorRef) {
    this.parentComponentGoals = new Goals(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }

  async ngOnInit() {
    const isLoggedIn = await this.checkIfUserIsLoggedIn();
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  onMealChange(mealViewModels: MealViewModel[]) {
    this.mealViewModels = mealViewModels;
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  onGoalsChange(goals: Goals) {
    this.parentComponentGoals = new Goals(
      goals.carbs,
      goals.fat,
      goals.protein,
      goals.alcohol,
      goals.totalCalories,
      goals.carbCalories,
      goals.fatCalories,
      goals.proteinCalories,
      goals.alcoholCalories,
      goals.carbsPercentage,
      goals.fatPercentage,
      goals.proteinPercentage,
      goals.alcoholPercentage
    );
    this.cdr.detectChanges(); // Manually trigger change detectio
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private checkIfUserIsLoggedIn(): Promise<boolean> {
    return new Promise((resolve) => {
      this.authService.isLoggedIn().subscribe((response: any) => {
        this.user.loggedin = response.isAuthenticated;
        this.user.username = response.userName ?? "";
        resolve(this.user.loggedin);
      });
    });
  }
}
